/**
 * Small formatters for the conversation list surfaces, kept out of the component files so
 * those keep fast refresh.
 */

import type { ConversationSummary } from '@/services/message.service';

export const fmtWhen = (iso: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const contactLabel = (c: ConversationSummary): string =>
  c.contact?.name || c.contact?.email || c.contact?.identifier || 'Unknown contact';
